module.exports = __webpack_public_path__ + "img/COL.e32eef7e.svg";